<template>
  <div class="widget">
    <slot></slot>
  </div>
</template>


<style lang="scss">
.widget {
  h1 {
    color: white;
  }
  h2 {
    font-size: 18px;
    font-weight: 700;
  }
  h3 {
    font-size: 14px;
    font-weight: 700;
    color: var(--grey)
  }
  h4 {
    font-size: 14px;
    font-weight: 400;
    color: black;
  }
  p {
    color: var(--grey);
  }
}

</style>
